"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrDesktopNavMenu = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const fdr_desktop_nav_link_1 = require("./fdr-desktop-nav-link");
const fdr_desktop_nav_sub_menu_1 = require("./fdr-desktop-nav-sub-menu");
const MenuListWrapper = styled_components_1.default.ul(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    '.sub-menu-link': theme.menu.navBarLink,
    '.nav-link': theme.menu.nav,
    '.menu-link-item': theme.menu.menuLinkItem,
    '.sub-menu-item': theme.menu.navBarItem,
}));
const FdrDesktopNavMenu = ({ menus, isSubMenuBlocked, internalLinkIconName, onClick, }) => {
    const [hideSubMenu, setHideSubMenu] = (0, react_1.useState)(false);
    return (react_1.default.createElement(MenuListWrapper, null, menus === null || menus === void 0 ? void 0 : menus.map((menu, i) => {
        var _a;
        return (react_1.default.createElement(react_1.default.Fragment, { key: i },
            react_1.default.createElement(fdr_desktop_nav_link_1.FdrDesktopNavLink, { item: menu, internalLinkIconName: internalLinkIconName, onLinkInteraction: () => {
                    setHideSubMenu(false);
                } }),
            !isSubMenuBlocked && ((_a = menu === null || menu === void 0 ? void 0 : menu.menuItems) === null || _a === void 0 ? void 0 : _a.length) > 0 && (react_1.default.createElement(fdr_desktop_nav_sub_menu_1.FdrDesktopNavSubMenu, { hideSubMenu: hideSubMenu, items: menu.menuItems, internalLinkIconName: internalLinkIconName, onClick: (link, j) => {
                    setHideSubMenu === null || setHideSubMenu === void 0 ? void 0 : setHideSubMenu(true);
                    onClick === null || onClick === void 0 ? void 0 : onClick(link, j, i);
                }, onLinkInteraction: () => {
                    setHideSubMenu === null || setHideSubMenu === void 0 ? void 0 : setHideSubMenu(false);
                } }))));
    })));
};
exports.FdrDesktopNavMenu = FdrDesktopNavMenu;
//# sourceMappingURL=fdr-desktop-nav-menu.js.map